import {Navigate, useLocation} from '@github-ui/react-router'

import {getAgentsRedirectLocation} from './copilot-agents-route'

export function AgentsRouteRedirect() {
  const {pathname, search, hash} = useLocation()
  return <Navigate to={getAgentsRedirectLocation({pathname, search, hash})} replace />
}
